import Image from "next/image";
import { BRAND_MARK_HEIGHT, BRAND_MARK_SRC, BRAND_MARK_WIDTH } from "@/lib/brand";

type BrandLogoProps = {
  /** Compact lockup for nav; mark-only for avatars. */
  variant?: "lockup" | "mark";
  className?: string;
  markClassName?: string;
  wordmarkClassName?: string;
  priority?: boolean;
};

export function BrandLogo({
  variant = "lockup",
  className = "",
  markClassName = "h-8 w-auto",
  wordmarkClassName = "text-[15px]",
  priority = false,
}: BrandLogoProps) {
  const mark = (
    <Image
      src={BRAND_MARK_SRC}
      alt={variant === "mark" ? "doimpo" : ""}
      width={BRAND_MARK_WIDTH}
      height={BRAND_MARK_HEIGHT}
      className={`block ${markClassName}`}
      priority={priority}
      unoptimized
    />
  );

  if (variant === "mark") {
    return <span className={`inline-flex items-center ${className}`}>{mark}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {mark}
      <span className={`font-display font-semibold tracking-tight text-white ${wordmarkClassName}`}>
        doimpo
      </span>
    </span>
  );
}
